var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"65bdd4ff9f23f2531456cb704fe6e045ceebefdb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kantaban-ui@perp"]={id:"65bdd4ff9f23f2531456cb704fe6e045ceebefdb"};
      